export const closeAllPopups = (clss) => {
  if (clss) {
    clss = "," + clss;
  } else {
    clss = "";
  }
  let popups = document.querySelectorAll(
    'a[href="#newsletter"], a[href="#selectlanguage"], a[href="#search"], a[href="#cigna"], #pop-newsletter, #pop-languages, #pop-search, .d-lightbox, .for-d-lightbox, #pop-wechat, #pop-cigna' +
      clss
  );

  document.querySelector("body").classList.remove("void-scroll");

  popups.forEach((elem) => {
    elem.classList.remove("active");
  });
};
